import { Injectable } from "@angular/core";
import { M3CouchMaestro } from "../Data/m3-couch-maestro"
import { variable } from "@angular/compiler/src/output/output_ast";
import { ServiceM3Maestro } from "../Services/M3Maestro.service";
import { AnyARecord } from "dns";

@Injectable({
    providedIn: 'root'
})
export class M3MaestroOffline {
    constructor(private oM3CouchMaestro: M3CouchMaestro) {

    }

    /**
     * Obtener formas de pago
     * @param idKatios Id de la Empresa 
     * @param respOk_get_formas_pago Funcion con respuesta OK
     * @param respError_get_formas_pago Funcion con respuesta ERROR
     */
    public GetFormasPago(idKatios, idProceso: string, respOk_get_formas_pago: Function, respError_get_formas_pago: Function) {
        this.oM3CouchMaestro.get("FormasPago").then(x => {
            console.log(x);

            respOk_get_formas_pago(this.FiltrarByProceso(idProceso, x.FormasPago));
        }, error => {
            respError_get_formas_pago(error);
            console.log(error);
        });
    }

    /**
     * Filtrar las formas de pago, dependiendo la informacion del proceso.
     * @param idProceso 
     * @param formasPago 
     */
    public FiltrarByProceso(idProceso: string, formasPago: Array<any>) {
        try {
            console.log(formasPago);
            if (idProceso != "") {
                formasPago = formasPago.filter(x => {
                    console.log(x);
                    if (x.PROCESOS) {
                        if (!x.PROCESOS.length)
                            x.PROCESOS = new Array<any>(x.PROCESOS);
                        return x.PROCESOS.find(y => y.IdProceso == idProceso) != null
                    } else {
                        return false;
                    }
                });
                console.log(formasPago);
            } else {
            }
        } catch (ex) {
            console.log("Error FiltrarByProceso");
            console.log(ex);
            return formasPago;
        }

        return formasPago;
    }

    public GetEstructura(est:string) {
        return this.oM3CouchMaestro.get(est);
    }

    /**
     * Obtener dinÃ¡micas por actividad
     * @param idKatios Id de la empresa
     * @param LoadDinamicasOK Funcion de respuesta OK
     * @param LoadDinamicasError Funcion de respuesta ERROR
     */
    public GetDinamicasByACtividad(idKatios, oData, LoadDinamicasOK: Function, LoadDinamicasError: Function) {
        var dinam
        this.oM3CouchMaestro.get("DINBYACT").then(x => {
            try {
                dinam = x.M3DinByActividad;
                dinam = dinam.filter(x => x.Actividad == oData.Actividad && x.IDActividad == oData.idActividad && x.IdProceso == oData.idProceso);
                LoadDinamicasOK(dinam);
            } catch{
                dinam = new Array<any>();
                LoadDinamicasOK(dinam);
            }

        }, error => {
            LoadDinamicasError(error);
            console.log(error);
        });
    }

    /**
     * Obtener informacion de ubicaciones
     * @param sIdUbicaciones Id de la ubicacion a buscar en base de datos NoSQL
     * @param oServiceM3Maestro Servicio maestro, esta tiene funcionalidad para buscar especificamente un ubicacion
     * @param FuncionOK Funcion que retoma la funcionalidad cuando es OK.
     */
    public GetUbicaciones(idkatios: string, sIdUbicaciones: string, oServiceM3Maestro: ServiceM3Maestro, FuncionOK: Function) {
        //Cargar informacion de ubicacion
        var oM3Ubicacion;
        var sIdUbicacionesCouch = idkatios.trim().toUpperCase() + "?UBIC";;
        this.oM3CouchMaestro.get(sIdUbicacionesCouch).then(result => {
            oM3Ubicacion = oServiceM3Maestro.GetUbicacionFromList(result.ListUbicaciones.M3UBICACION, sIdUbicaciones);
            FuncionOK(oM3Ubicacion);

        }, error => {
            console.log(error);
        });
    }


   

    // /**
    //  * Obtener la informacion de las promociones
    //  * @param sIDPromo Id de la promocion a buscar en base de datos NoSQL
    //  * @param FuncionOK Funcion que retoma la funcionalidad cuando es OK.
    //  */
    // public GetPromociones(idkatios: string, FuncionOK: Function) {
    //     var ListPromo;
    //     var sIDPromo = idkatios.trim().toUpperCase() + "?Promociones";
    //     this.oM3CouchMaestro.get(sIDPromo).then(result => {
    //         if(result.M3ENCPROMO){
    //             ListPromo = result.M3ENCPROMO;
    //         }else if(result.M3ListENCPROMO.M3ENCPROMO){
    //             ListPromo = result.M3ListENCPROMO.M3ENCPROMO;
    //         }else{
    //             ListPromo = undefined;
    //         }

    //         FuncionOK(ListPromo);
    //     }, error => {
    //         console.log(error);
    //     });
    // }

    /**
     * Obtener la informacion sincrÃ³nicamente de template. segun el reporte entrante 
     * @param idkatios 
     */
    public async Asyncget_template_reporte(idkatios: string, idrep) {
        try {
            var template;
            //var sID = idkatios.trim().toUpperCase() + "?Templates";
            var sID = "TEMPLATES";
            template = await this.oM3CouchMaestro.get(sID);
            if (template.RESPUESTA.RPTemplate.length == undefined) {
                template = new Array<any>(template.RESPUESTA.RPTemplate);
            } else {
                template = template.RESPUESTA.RPTemplate;
            }
            ///Se crean los nodos padre RESPUESTA y RPTemplate, para simular igual, como lo responde servidor.
            var templateUno = { "RESPUESTA": { "RPTemplate": template.find(t => t.IdRep == idrep) } };
            return templateUno;
        } catch{
            return null;
        }
    }



}   